import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Stack,
  Button,
  Box,
  Tabs,
  Tab,
  Alert,
  AlertTitle,
  Autocomplete,
} from "@mui/material";
import moment from "moment";
import { a11yProps } from "../../common/components/TabPanel";
import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import {
  approveExitRequest,
  cancelExitRequest,
  signExitRequest,
  rejectRequest,
  getEmployeeExitRequest,
  cancelEmployeeExitRequest,
  verifyExitRequest,
  saveOrUpdateDraftRequest,
  updateAppointingAuthorityInstitutionRequest,
} from "../../../store/exit/actions";
import { getAllPlanningEntities } from "../../../store/rbm/actions";
import ConfirmationDialog from "../../common/components/ConfirmationDialog";
import { showError, showSuccess } from "../../toastify";

import { useRequiredAuth } from "../../common/guard/requiredAuth";
import EditExitRequestLetterDialog from "../../employees/components/EditExitRequestLetterDialog";
import PdfViewer from "../../common/components/PdfViewer";
import {
  containsKeyInReplacements,
  replaceTextPlaceholders,
  textCapitalized,
} from "../../common/components/Utils";
import ViewExitRequestAttachments from "./ViewExitRequestAttachments";
import InstitutionDetails from "../../training/components/InstitutionDetails";
import TextEditorComponent from "../../common/components/TextEditorComponent";
import CustomizedLetter from "../../documents/LetterFormat/CustomizedLetter";
import SignLetter from "../../documents/LetterFormat/SignLetter";
import ViewApproverLogs from "./ViewApproverLogs";
import { ReactMultiEmail } from "react-multi-email";
import "react-multi-email/dist/style.css";
const maxCharCount = 1500;

const ViewExitDialog = (props) => {
  const {
    loading,
    approveRequestForm,
    setApproveRequestForm,
    rejectRequest,
    employeeExitRequest,
    approveExitRequest,
    cancelEmployeeExitRequest,
    verifyExitRequest,
    env,
    saveOrUpdateDraftRequest,
    signExitRequest,
    user,
    allPlanningEntities,
    getAllPlanningEntities,
    updateAppointingAuthorityInstitutionRequest,
    cancelExitRequest,
  } = props;
  const [conditions, setConditions] = useState({
    isAttachmentRequired: true, // Change this to false or null to test removal of "Fill Attachment(s)"
    enableToGenerateLetter: true, // Change this to false to test removal of "Fill Request Letter"
  });
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);

  const [letterFooterContent, setLetterFooterContent] = useState(null);
  const [exitType, setExitType] = useState(null);
  const [
    showAppointingAuthorityInstitutionDialog,
    setShowAppointingAuthorityInstitutionDialog,
  ] = useState(false);
  const [
    selectedAppointingAuthorityPlanningEntity,
    setSelectedAppointingAuthorityPlanningEntity,
  ] = useState(null);

  const [localStorageKey, setLocalStorageKey] = useState({
    letter: `${employeeExitRequest && employeeExitRequest.employeePositionId}-${
      employeeExitRequest && employeeExitRequest.exitTypeId
    }-draftExitContent`,
    cc: `${employeeExitRequest && employeeExitRequest.employeePositionId}-${
      employeeExitRequest && employeeExitRequest.exitTypeId
    }-copiedInstitution`,
  });
  const [tabValue, setTabValue] = useState(0);
  const [showCancelConfirmationDialog, setShowCancelConfirmationDialog] =
    useState(false);

  const [showConfirmExit, setShowConfirmExit] = useState(false);
  const [enableToFillLetter, setEnableToFillLetter] = useState(
    [1010].includes(employeeExitRequest.statusId) ? true : false,
  );
  const [newStatusId, setNewStatusId] = useState(null);
  const [showRejectRequestForm, setShowRejectRequestForm] = useState(false);
  const [showApproveRequestForm, setShowApproveRequestForm] = useState(false);
  const [reason, setReason] = useState("");
  const [pkiPassword, setPkiPassword] = useState("");
  const [replacements, setReplacements] = useState({
    appointingReferLetterNo: "",
    appointingReferLetterDate: "",
    currentPositionName: "",
    currentEntityName: "",
    tranferredPositionName: "",
    tranferredEntityName: "",
    committeeReportDate: "",
    giveTheDetailsOfFaults: "",
    periodFrom: "",
    serviceName: "",
    effectiveDate: moment().format("LL"),
  });
  const [ccEmails, setCCEmails] = useState(
    employeeExitRequest && !!employeeExitRequest.cc
      ? JSON.parse(employeeExitRequest?.cc || [])
      : [],
  );
  const uniquePlanningEntities = useMemo(() => {
    if (!Array.isArray(allPlanningEntities)) return [];
    const seen = new Set();
    return allPlanningEntities.filter((entity) => {
      if (!entity || !entity.id) return false;
      if (seen.has(entity.id)) return false;
      seen.add(entity.id);
      return true;
    });
  }, [allPlanningEntities]);

  useEffect(() => {
    setConditions((conditions) => ({
      ...conditions,
      isAttachmentRequired: employeeExitRequest.isAttachmentRequired,
      enableToGenerateLetter: employeeExitRequest.enableToGenerateLetter,
    }));
  }, [employeeExitRequest]);

  const [employeeExitForm, setEmployeeExitForm] = useState({
    requestId: employeeExitRequest?.id || null,
    employeeId: employeeExitRequest?.employeeId || null,
    employeePositionId: employeeExitRequest?.employeePositionId || "",
    positionId: employeeExitRequest?.positionId || "",
    transferredPositionId: employeeExitRequest?.toPositionId || "",
    exitTypeId: employeeExitRequest?.exitTypeId || 0,
    effectiveDate: moment(employeeExitRequest?.effectiveOn || null).format(
      "YYYY-MM-DD",
    ),
    blacklistPeriod: employeeExitRequest?.blacklistPeriod || 0,
    reason: employeeExitRequest?.reason || "",
    letterBodyContent: employeeExitRequest?.letterBodyContent || "",
    docLetterNo: employeeExitRequest?.docLetterNo || "",
    entitySectorId:
      employeeExitRequest?.entitySectorId ||
      employeeExitRequest?.entitySectorId ||
      null,
    cc:
      employeeExitRequest && !!employeeExitRequest.cc
        ? JSON.parse(employeeExitRequest?.cc || [])
        : [],
    copiedInstitutionContent:
      employeeExitRequest?.copiedInstitutionContent || "",

    docReferenceId: !!employeeExitRequest?.docReferenceId
      ? employeeExitRequest.docReferenceId
      : null,
    requestPlanningEntityId:
      employeeExitRequest?.requestPlanningEntityId || null,
    appointingAuthorityPlanningEntityId:
      employeeExitRequest?.appointingAuthorityPlanningEntityId || null,
  });

  useEffect(() => {
    if (!uniquePlanningEntities.length) {
      let isMounted = true;
      getAllPlanningEntities((status) => {
        if (isMounted) {
          // setLoadingPlanningEntities(status);
        }
      });
      return () => {
        isMounted = false;
      };
    }
  }, []);

  useEffect(() => {
    // console.log(position.appointingAuthorityPlanningEntityId);
    setSelectedAppointingAuthorityPlanningEntity(
      uniquePlanningEntities.find(
        ({ id }) =>
          id === employeeExitRequest?.appointingAuthorityPlanningEntityId,
      ) || null,
    );
  }, [
    employeeExitRequest?.appointingAuthorityPlanningEntityId,
    uniquePlanningEntities,
  ]);

  const [errors, setErrors] = useState({
    exitTypeHasError: false,
    reasonHasError: false,
    effectiveDateHasError: false,
    entityHasError: false,
    unitHasError: false,
    positionHasError: false,
    effectiveDateError: false,
    docLetterNoError: false,
    ccHasError: false,
  });
  const formValidator1 = () => {
    const error = {
      exitTypeHasError: false,
      reasonHasError: false,
      effectiveDateHasError: false,
      entityHasError: false,
      unitHasError: false,
      positionHasError: false,
      effectiveDateError: false,
      docLetterNoError: false,
      ccHasError: false,
      hasError: false,
    };

    setErrors(error);

    if (error.hasError) {
      showError(`Please fill required field!`);
      return true;
    }
    return false;
  };

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const onClose = () => {
    setShowCancelConfirmationDialog(false);
    setApproveRequestForm(false);
    setShowRejectRequestForm(false);
    setShowApproveRequestForm(false);
  };

  const [showEmployeeExitForm, setShowEmployeeExitForm] = useState(false);

  const { hasPermissions } = useRequiredAuth();

  const handleSubmitDraftRequest = () => {
    if (
      !!employeeExitRequest.letterBodyContent &&
      !!errors.draftContentMaxCharHasError
    ) {
      showError(
        `The letter content should not exceed 1.5MB. Please reduce the number of characters.`,
      );
      return false;
    }
    // console.log( window.localStorage.getItem(localStorageKey.letter) );
    if (
      !!employeeExitRequest.enableToGenerateLetter &&
      window.localStorage.getItem(localStorageKey.letter)
    ) {
      employeeExitRequest.letterBodyContent = window.localStorage.getItem(
        localStorageKey.letter,
      );
    }
    if (
      !!employeeExitRequest.enableToGenerateLetter &&
      window.localStorage.getItem(localStorageKey.cc)
    ) {
      employeeExitRequest.copiedInstitutionContent =
        window.localStorage.getItem(localStorageKey.cc);
    }

    if (
      !!employeeExitRequest.enableToGenerateLetter &&
      replacePlaceholders(employeeExitRequest.letterBodyContent, true)
    ) {
      showError(
        `Please update the following Placeholder: {appointingReferLetterNo}, {appointingReferLetterDate} `,
      );
      return false;
    }
    // Regular expression to match one or more occurrences of <div><br /></div>
    const regex = new RegExp('(<div><br></div>)+');

    // if (
    //   !!employeeExitRequest.enableToGenerateLetter &&
    //   !!regex.test(employeeExitRequest.copiedInstitutionContent) &&
    //   !!ccEmails.length
    // ) {
    //   showError(
    //     `You've added the CC emails, but you didn't include the copied institution content.`
    //   );
    //   return false;
    // }

    // if (
    //   !!employeeExitRequest.enableToGenerateLetter &&
    //   !regex.test(employeeExitRequest.copiedInstitutionContent) &&
    //   !ccEmails.length
    // ) {
    //   showError(
    //     `You've included the copied institution content, but you didn't add the CC emails.`
    //   );
    //   return false;
    // }

    // console.log( employeeExitForm );

    saveOrUpdateDraftRequest(
      {
        ...employeeExitForm,
        effectiveDate: moment(employeeExitRequest.effectiveDate).format(
          "YYYY-MM-DD",
        ),
        requestId: employeeExitRequest?.id || null,
        cc: ccEmails || [],
        letterBodyContent: employeeExitRequest.letterBodyContent,
        copiedInstitutionContent: employeeExitRequest.copiedInstitutionContent,
        appointingAuthorityPlanningEntityId:
          employeeExitRequest.appointingAuthorityPlanningEntityId || null,
        requestPlanningEntityId:
          employeeExitRequest.requestPlanningEntityId || null,
      },
      (status) => {
        showSuccess("Letter updated successfully.");
        if (!!status) {
          if (
            !!employeeExitRequest.enableToGenerateLetter &&
            !!employeeExitRequest
          ) {
            window.localStorage.setItem(
              localStorageKey.letter,
              employeeExitForm.letterBodyContent,
            );

            setEmployeeExitForm({
              ...employeeExitForm,
              letterBodyContent: employeeExitRequest.letterBodyContent,
              appointingAuthorityPlanningEntityId:
                employeeExitRequest.appointingAuthorityPlanningEntityId || null,
            });
          }
        }
      },
    );
  };

  const handleUpdateAppointingAuthorityInstitutionRequest = () => {
    if (!selectedAppointingAuthorityPlanningEntity) {
      showError("Please select the appointing authority institution");
      return false;
    }
    updateAppointingAuthorityInstitutionRequest(
      {
        requestId: employeeExitRequest.id,
        appointingAuthorityPlanningEntityId:
          selectedAppointingAuthorityPlanningEntity?.id || null,
      },
      (status) => {
        if (!!status) {
          showSuccess("Appointing authority institution updated successfully.");
          setShowAppointingAuthorityInstitutionDialog(false);
          setEmployeeExitForm({
            ...employeeExitForm,
            appointingAuthorityPlanningEntityId:
              selectedAppointingAuthorityPlanningEntity?.id || null,
          });
        }
      },
    );
  };

  const handleConfirmRequest = () => {
    // if (
    //   !!employeeExitRequest.letterBodyContent &&
    //   !!errors.draftContentMaxCharHasError
    // ) {
    //   showError(
    //     `The letter content should not exceed 1.5MB. Please reduce the number of characters.`
    //   );
    //   return false;
    // }

    let letterBodyContent = employeeExitRequest.letterBodyContent;
    let copiedInstitutionContent = employeeExitRequest.copiedInstitutionContent;

    if (
      !!employeeExitRequest.enableToGenerateLetter &&
      window.localStorage.getItem(localStorageKey.letter)
    ) {
      letterBodyContent = window.localStorage.getItem(localStorageKey.letter);
    }
    if (
      !!employeeExitRequest.enableToGenerateLetter &&
      window.localStorage.getItem(localStorageKey.letter)
    ) {
      copiedInstitutionContent = window.localStorage.getItem(
        localStorageKey.cc,
      );
    }

    if (
      newStatusId !== 1002 &&
      !!employeeExitRequest.enableToGenerateLetter &&
      replacePlaceholders(letterBodyContent, true)
    ) {
      showError(
        `Please update the following Placeholder: {appointingReferLetterNo}, {appointingReferLetterDate}`,
      );
      return false;
    }
    // Regular expression to match one or more occurrences of <div><br /></div>
    const regex = new RegExp('(<div><br></div>)+');

    // if (
    //   !!employeeExitRequest.enableToGenerateLetter &&
    //   !!regex.test(employeeExitRequest.copiedInstitutionContent) &&
    //   !!ccEmails.length
    // ) {
    //   showError(
    //     `You've added the CC emails, but you didn't include the copied institution content.`
    //   );
    //   return false;
    // }

    // if (
    //   !!employeeExitRequest.enableToGenerateLetter &&
    //   !regex.test(employeeExitRequest.copiedInstitutionContent) &&
    //   !ccEmails.length
    // ) {
    //   showError(
    //     `You've included the copied institution content, but you didn't add the CC emails.`
    //   );
    //   return false;
    // }

    // console.log( employeeExitForm );

    if (!formValidator1()) {
      verifyExitRequest(
        {
          ...employeeExitForm,
          requestId: employeeExitRequest.id,
          employeePositionId: employeeExitRequest.employeePositionId,
          cc: ccEmails || [],
          reason,
          newStatusId,
          letterBodyContent: letterBodyContent,
          copiedInstitutionContent: copiedInstitutionContent,
        },
        onClose,
      );
    }
  };

  const getEditorContent = (data) => {
    let draftContentMaxCharHasError = false;
    setEmployeeExitForm({
      ...employeeExitForm,
      letterBodyContent: data.contents,
    });
    if (!!data.isMaxChar) draftContentMaxCharHasError = true;

    setErrors({
      ...errors,
      draftContentMaxCharHasError: draftContentMaxCharHasError,
    });
  };
  const getEditorContent3 = (data) => {
    setEmployeeExitForm({
      ...employeeExitForm,
      copiedInstitutionContent: data.contents,
    });
    employeeExitRequest.copiedInstitutionContent = data.contents;
  };
  const replacePlaceholders = (
    template,
    isVerifyContainsKeyInReplacement = false,
  ) => {
    if (!!isVerifyContainsKeyInReplacement)
      return containsKeyInReplacements(template, replacements);
    return replaceTextPlaceholders(template, replacements);
  };
  // console.log(employeeExitRequest);
  const handleLoadFooterContent = (data) => {
    // console.log(data);
    setLetterFooterContent(data);
  };
  // console.log(user);
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={approveRequestForm}
        fullWidth
        maxWidth={"md"}
      >
        {showEmployeeExitForm && (
          <EditExitRequestLetterDialog
            showEmployeeExitForm={showEmployeeExitForm}
            setShowEmployeeExitForm={setShowEmployeeExitForm}
          />
        )}
        <DialogTitle>
          <Typography
            variant="overline"
            display="block"
            className="font-weight-bold"
          >
            <div className="row">
              <div className="col-12">
                <span>Exit Request </span> /{" "}
                <span className="text-primary mr-1">
                  {employeeExitRequest?.exitType || ""}
                </span>
                - {employeeExitRequest?.employeeNames || ""}
              </div>
              <div className="col-12">
                <small
                  className="fw-bold text-truncate text-dark"
                  style={{ fontSize: "12px" }}
                >
                  {textCapitalized(employeeExitRequest?.entityName || "")}
                </small>
                <span
                  style={{ fontSize: "12px" }}
                  className="fas fa-angle-right ml-1"
                ></span>
                <small
                  className="ml-1 fw-bold text-truncate text-success"
                  style={{ fontSize: "12px" }}
                >
                  {textCapitalized(employeeExitRequest?.positionName || "")}
                </small>
              </div>
            </div>
          </Typography>
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>

          <div className="mt-4">
            <Box sx={{ width: "100%", mt: 0 }}>
              {/* {!!employeeExitRequest && (
                          <Alert
                            className="mt-2"
                            variant="outlined"
                            severity={"warning"}
                            sx={{
                              padding: "1px 15px 0px",
                              width: "100%",
                            }}
                            // icon={<CircleNotificationsIcon style={{ color: "#0099e8" }} />}
                            action={
                              <>
                                <Button
                                  className="mt-0 mr-3"
                                  onClick={() => setShowConfirmationDialog(true)}
                                >
                                  Cancel this request
                                </Button>
                              </>
                            }
                          >
                            You can also cancel this {employeeExitRequest.statusName} exit
                            request!
                          </Alert>
                        )}
                         {showConfirmationDialog && (
                                <ConfirmationDialog
                                  confirmationDialog={showConfirmationDialog}
                                  message={`Are you sure you want to cancel the exit request?`}
                                  setConfirmationDialog={setShowConfirmationDialog}
                                  onYes={() => {
                                    if (employeeExitRequest && employeeExitRequest.enableToFillLetter) {
                                      window.localStorage.removeItem(localStorageKey.letter);
                                      window.localStorage.removeItem(localStorageKey.cc);
                                    }
                                    cancelEmployeeExitRequest(
                                      employeeExitRequest,
                        
                                      onClose
                                    );
                                  }}
                                />
                              )} */}
              <Tabs
                className="mt-2 justify-content-end"
                value={tabValue}
                onChange={handleChange}
                aria-label="tabs"
                allowScrollButtonsMobile
                variant="scrollable"
                scrollButtons="auto"
              >
                {conditions && !!conditions.enableToGenerateLetter && (
                  <Tab
                    className="text-capitalize"
                    label="View Letter"
                    {...a11yProps(0)}
                  />
                )}

                <Tab
                  className="text-capitalize"
                  label="Details & Attachments "
                  {...a11yProps(
                    conditions && !conditions.enableToGenerateLetter ? 0 : 1,
                  )}
                />

                <Tab
                  className="text-capitalize"
                  label="Approvers' Logs"
                  {...a11yProps(
                    conditions && !conditions.enableToGenerateLetter ? 1 : 2,
                  )}
                />
              </Tabs>
            </Box>
            {employeeExitRequest && (
              <span
                style={{ fontSize: "12px" }}
                className={`${
                  +employeeExitRequest.statusId === 2
                    ? "badge badge-success w-100"
                    : [3, 1002].includes(+employeeExitRequest.statusId)
                      ? "badge badge-danger w-100"
                      : [1, 1006].includes(+employeeExitRequest.statusId)
                        ? "badge badge-primary w-100"
                        : [1003, 1008, 1010].includes(
                              +employeeExitRequest.statusId,
                            )
                          ? "badge badge-warning w-100"
                          : "badge badge-secondary w-100"
                }`}
              >
                {employeeExitRequest.statusName}
              </span>
            )}
            {[1, 1003, 1005, 1007, 1006, 1008, 1010].includes(
              employeeExitRequest.statusId,
            ) &&
              enableToFillLetter &&
              tabValue === 0 && (
                <Button
                  disabled={loading}
                  onClick={handleSubmitDraftRequest}
                  color={"primary"}
                  variant="contained"
                  size="small"
                  className="float-right mx-1 my-1"
                >
                  {loading ? "Wait.." : <> Save Changes</>}
                </Button>
              )}

            {[1, 1003, 1005, 1007, 1006, 1008, 1010].includes(
              employeeExitRequest.statusId,
            ) &&
              !!conditions.enableToGenerateLetter &&
              tabValue === 0 && (
                <Button
                  variant="outlined"
                  color={enableToFillLetter ? "warning" : "info"}
                  size="small"
                  disabled={loading}
                  onClick={() => {
                    setEnableToFillLetter(!enableToFillLetter);
                    // getNPSCReport(
                    //   npscReportDetail.id,
                    //   setShowSubmissionReport,
                    //   () => {}
                    // );
                  }}
                  className="mx-1 my-1 text-capitalized float-right px-3"
                >
                  {enableToFillLetter ? "Preview" : "Edit Letter"}
                </Button>
              )}
          </div>
        </DialogTitle>

        <DialogContent>
          {employeeExitRequest && (
            <Box sx={{ width: "100%", minHeight: "95vh" }} className="mt-1">
              {tabValue === 0 &&
                employeeExitRequest &&
                !!conditions.enableToGenerateLetter &&
                [3, 2, 1002].includes(employeeExitRequest.statusId) && (
                  <>
                    {employeeExitRequest.statusId === 2 && (
                      <>
                        {!!employeeExitRequest?.docReferenceId && (
                          <>
                            <PdfViewer
                              url={
                                process.env.REACT_APP_FILES_URL +
                                "/preview/" +
                                employeeExitRequest?.docReferenceId
                              }
                            />
                          </>
                        )}
                        {!employeeExitRequest?.docReferenceId && (
                          <>
                            <div
                              className="card  w-100"
                              style={{
                                backgroundColor: "#fff",
                                borderLeft: "2px solid #3f51b5",
                                borderLeft: "2px solid #3f51b5",
                                borderRadius: "4px",
                              }}
                            >
                              <div className="card-body w-100">
                                <p className="small p-0 ms-2 mb-0 rounded-3">
                                  No letter was found because the request was
                                  approved when this feature wasn't in the
                                  system.
                                  <br />
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    className="mt-2"
                                    onClick={() => {
                                      setTabValue(1);
                                    }}
                                  >
                                    View request details
                                  </Button>
                                </p>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}
              {tabValue === 0 &&
                employeeExitRequest &&
                !!conditions.enableToGenerateLetter &&
                [1, 1003, 1005, 1007, 1006, 1008, 1010].includes(
                  employeeExitRequest.statusId,
                ) && (
                  <>
                    <div className="mx-2 w-full">
                      <CustomizedLetter
                        disableToEditLetterHeader={true}
                        enableToFillLetter={enableToFillLetter}
                        ccSelectForm={
                          <>
                            <strong>Enter CC Institution Email</strong>
                            <ReactMultiEmail
                              placeholder="Enter CC Institution Email"
                              emails={ccEmails}
                              onChange={(_emails) => {
                                setCCEmails(_emails);
                              }}
                              getLabel={(email, index, removeEmail) => {
                                return (
                                  <div data-tag key={index}>
                                    {email}
                                    <span
                                      data-tag-handle
                                      onClick={() => removeEmail(index)}
                                    >
                                      ×
                                    </span>
                                  </div>
                                );
                              }}
                            />
                          </>
                        }
                        ccEmails={ccEmails}
                        docLetterNo={employeeExitRequest?.docLetterNo || ""}
                        signContent={
                          <>
                            <InstitutionDetails
                              headOfInstitution={{
                                isDelegated:
                                  employeeExitRequest?.isActingHeadOfInstitution ||
                                  false,
                                isMinster:
                                  employeeExitRequest?.isMinster || false,
                                firstName:
                                  employeeExitRequest?.ministryApproverFirstName,
                                lastName:
                                  employeeExitRequest?.ministryApproverLastName,
                                institutionName:
                                  employeeExitRequest?.ministryApproverInstitutionName,
                                positionName:
                                  employeeExitRequest?.ministryApproverPositionName,
                                institutionName:
                                  employeeExitRequest?.ministryApproverInstitutionName ||
                                  "",
                                canAddInstitutionName:
                                  employeeExitRequest?.ministryApproverCanAddInstitutionName ||
                                  false,
                              }}
                              userSignature={null}
                            />
                          </>
                        }
                        subTitle={
                          "Dear " +
                          (employeeExitRequest?.lastName?.toUpperCase() +
                            " " +
                            employeeExitRequest?.firstName)
                        }
                        recipientContent={
                          <>
                            {employeeExitRequest?.lastName?.toUpperCase() +
                              " " +
                              employeeExitRequest?.firstName}{" "}
                            <br />
                            Tel: {employeeExitRequest?.phoneNumber} <br />
                            Email: {employeeExitRequest?.email} <br />
                          </>
                        }
                        planningEntityId={
                          employeeExitRequest?.appointingAuthorityPlanningEntityId ||
                          employeeExitRequest?.requestPlanningEntityId ||
                          null
                        }
                        letterBodyContentInput={
                          <>
                            <TextEditorComponent
                              id="editor-exit-textarea"
                              options={{
                                autoSave: false,
                                localStorageKey: localStorageKey.letter,
                                maxCharCount: maxCharCount,
                                defaultValue: !!window.localStorage.getItem(
                                  localStorageKey.letter,
                                )
                                  ? window.localStorage.getItem(
                                      localStorageKey.letter,
                                    )
                                  : employeeExitRequest.letterBodyContent,
                              }}
                              onEditorChange={(data) => {
                                getEditorContent(data);
                              }}
                            />
                          </>
                        }
                        letterBodyContent={
                          employeeExitRequest?.letterBodyContent || ""
                        }
                        title={employeeExitRequest?.letterTitle || ""}
                        copiedInstitutionContentInput={
                          <>
                            <br />
                            <strong>Enter CC Institution Name</strong>
                            <TextEditorComponent
                              id="editor-textarea6"
                              options={{
                                autoSave: false,
                                height: "200px",
                                localStorageKey: localStorageKey.cc,
                                maxCharCount: maxCharCount,
                                defaultValue: !!window.localStorage.getItem(
                                  localStorageKey.cc,
                                )
                                  ? window.localStorage.getItem(
                                      localStorageKey.cc,
                                    )
                                  : employeeExitRequest.copiedInstitutionContent,
                              }}
                              onEditorChange={(data) => {
                                getEditorContent3(data);
                              }}
                            />
                          </>
                        }
                        copiedInstitutionContent={
                          employeeExitRequest?.copiedInstitutionContent || ""
                        }
                        loadFooterContent={(data) =>
                          handleLoadFooterContent(data)
                        }
                      />
                    </div>
                  </>
                )}
              {((!!conditions.enableToGenerateLetter && tabValue === 1) ||
                (!conditions.enableToGenerateLetter && tabValue === 0)) && (
                <>
                  <table>
                    <tbody>
                      <tr>
                        <th scope="row">Employee</th>
                        <td>
                          {employeeExitRequest?.employeeNames ||
                            employeeExitRequest.lastName +
                              " " +
                              employeeExitRequest.firstName}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Exit request</th>
                        <td className="py-2 px-2">
                          <strong className="text-primary">
                            {employeeExitRequest.exitType}
                          </strong>
                          {employeeExitRequest.exitTypeId === 0 && (
                            <>
                              <div className="text-capitalize d-block">
                                From
                              </div>

                              <div className="text-capitalize d-block">
                                <small
                                  className="fw-bold text-truncate text-dark"
                                  style={{ fontSize: "12px" }}
                                >
                                  {textCapitalized(
                                    employeeExitRequest?.entityName || "",
                                  )}
                                </small>
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="fas fa-angle-right mx-1"
                                ></span>

                                <small
                                  className="fw-bold text-truncate text-dark"
                                  style={{ fontSize: "12px" }}
                                >
                                  {textCapitalized(
                                    employeeExitRequest?.unitName || "",
                                  )}
                                </small>
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="fas fa-angle-right mx-1"
                                ></span>

                                <small
                                  className="ml-1 fw-bold text-truncate text-success"
                                  style={{ fontSize: "12px" }}
                                >
                                  {textCapitalized(
                                    employeeExitRequest?.positionName || "",
                                  )}
                                </small>
                              </div>

                              <span className="text-capitalize d-block">
                                To
                              </span>
                              <div className="text-capitalize d-block">
                                <small
                                  className="fw-bold text-truncate text-dark"
                                  style={{ fontSize: "12px" }}
                                >
                                  {textCapitalized(
                                    employeeExitRequest?.toEntityName || "",
                                  )}
                                </small>
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="fas fa-angle-right mx-1"
                                ></span>

                                <small
                                  className="fw-bold text-truncate text-dark"
                                  style={{ fontSize: "12px" }}
                                >
                                  {textCapitalized(
                                    employeeExitRequest?.toUnitName || "",
                                  )}
                                </small>
                                <span
                                  style={{ fontSize: "12px" }}
                                  className="fas fa-angle-right mx-1"
                                ></span>

                                <small
                                  className="ml-1 fw-bold text-truncate text-success"
                                  style={{ fontSize: "12px" }}
                                >
                                  {textCapitalized(
                                    employeeExitRequest?.toPositionName || "",
                                  )}
                                </small>
                              </div>
                            </>
                          )}
                          {employeeExitRequest.exitTypeId === 6 && (
                            <>
                              <span className="text-capitalize d-block">
                                To
                              </span>
                              <div className="t d-block">
                                <div>{employeeExitRequest.toEntityName}</div> on
                                the post of
                                <strong className="ml-1 text-dark">
                                  {employeeExitRequest.toPositionName}(
                                  {employeeExitRequest.toUnitName})
                                </strong>
                              </div>
                            </>
                          )}
                        </td>
                      </tr>

                      <tr>
                        <th scope="row">
                          {employeeExitRequest?.exitTypeId === 7
                            ? "Date of Death"
                            : "Effective Date"}
                        </th>
                        <td>
                          {moment(employeeExitRequest.effectiveDate).format(
                            "LL",
                          )}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Requested Date</th>
                        <td>
                          {moment(employeeExitRequest.createdOn).format("LLL")}
                        </td>
                      </tr>
                      <tr>
                        <th scope="row">Request By</th>
                        <td>{employeeExitRequest.requestedBy}</td>
                      </tr>
                      {employeeExitRequest.verifiedBy && (
                        <>
                          <tr>
                            <th scope="row">Verified By</th>
                            <td>{employeeExitRequest.verifiedBy}</td>
                          </tr>
                          <tr>
                            <th scope="row">Verified On</th>
                            <td>
                              {" "}
                              {moment(employeeExitRequest.verifiedOn).format(
                                "LLL",
                              )}
                            </td>
                          </tr>
                        </>
                      )}

                      {employeeExitRequest.statusId === 3 && (
                        <>
                          <tr>
                            <th scope="row">Rejected By</th>
                            <td>{employeeExitRequest.statusByName}</td>
                          </tr>
                          <tr>
                            <th scope="row">Rejected On</th>
                            <td>
                              {" "}
                              {moment(employeeExitRequest.statusOn).format(
                                "LLL",
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                      {employeeExitRequest.statusId === 2 && (
                        <>
                          <tr>
                            <th scope="row">Approved By</th>
                            <td>{employeeExitRequest.statusByName}</td>
                          </tr>
                          <tr>
                            <th scope="row">Approved On</th>
                            <td>
                              {" "}
                              {moment(employeeExitRequest.statusOn).format(
                                "LLL",
                              )}
                            </td>
                          </tr>
                        </>
                      )}
                      {!!employeeExitRequest.reason && (
                        <tr className={`border border-primary`}>
                          <th scope="row">Reason for Exit</th>
                          <td>{employeeExitRequest.reason}</td>
                        </tr>
                      )}
                      <tr>
                        <th scope="row">Status</th>
                        <td>
                          <span
                            className={`badge badge-${
                              [1, 1006].includes(+employeeExitRequest.statusId)
                                ? "secondary"
                                : [3, 1002].includes(
                                      +employeeExitRequest.statusId,
                                    )
                                  ? "danger"
                                  : employeeExitRequest.statusId === 2
                                    ? "success"
                                    : [1003, 1008, 1010].includes(
                                          +employeeExitRequest.statusId,
                                        )
                                      ? "warning"
                                      : "primary"
                            }`}
                          >
                            {employeeExitRequest.statusName}
                          </span>
                        </td>
                      </tr>
                      {
                        //employeeExitRequest.enableToGenerateLetter &&
                        [1003, 1004].includes(employeeExitRequest.statusId) ? (
                          <tr>
                            <th scope="row">
                              Appointing Authority Institution
                            </th>
                            <td>
                              {selectedAppointingAuthorityPlanningEntity?.name ||
                                employeeExitRequest.appointingAuthorityInstitutionName}
                              <IconButton
                                onClick={() => {
                                  setShowAppointingAuthorityInstitutionDialog(
                                    true,
                                  );
                                }}
                              >
                                <span className="material-icons mr-1 text-primary">
                                  edit
                                </span>
                              </IconButton>
                            </td>
                            <Dialog
                              open={showAppointingAuthorityInstitutionDialog}
                              onClose={() => {
                                setShowAppointingAuthorityInstitutionDialog(
                                  false,
                                );
                              }}
                            >
                              <DialogTitle>
                                Appointing Authority Institution
                              </DialogTitle>
                              <DialogContent>
                                <div className="col-12 mt-3">
                                  <Autocomplete
                                    fullWidth
                                    size="small"
                                    id="appointingAuthorityPlanningEntityId"
                                    defaultValue={null}
                                    value={
                                      selectedAppointingAuthorityPlanningEntity
                                    }
                                    options={uniquePlanningEntities}
                                    isOptionEqualToValue={(option, value) =>
                                      option.id === value.id
                                    }
                                    onChange={(event, row) => {
                                      setSelectedAppointingAuthorityPlanningEntity(
                                        row || null,
                                      );
                                      setEmployeeExitForm({
                                        ...employeeExitForm,
                                        appointingAuthorityPlanningEntityId:
                                          row?.id || "",
                                      });
                                    }}
                                    getOptionLabel={(option) =>
                                      option.name +
                                        " / " +
                                        option.entitySector?.sector.name || ""
                                    }
                                    renderOption={(props, row) => (
                                      <Box component="li" {...props}>
                                        {row.name}
                                        {row.entitySector?.sector ? (
                                          <span className="ml-2 badge badge-primary">
                                            {row.entitySector?.sector.name}
                                          </span>
                                        ) : (
                                          ""
                                        )}{" "}
                                        {row.id ===
                                        employeeExitRequest.appointingAuthorityPlanningEntityId ? (
                                          <span className="ml-2 badge badge-success">
                                            Selected
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </Box>
                                    )}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label="Please select the appointing authority institution(if applicable)"
                                        placeholder="Please select the appointing authority institution(if applicable)"
                                        inputProps={{
                                          ...params.inputProps,
                                          autoComplete:
                                            "appointingAuthorityPlanningEntityId", // disable autocomplete and autofill
                                        }}
                                      />
                                    )}
                                  />

                                  <Alert severity="info" className="mt-3">
                                    <AlertTitle>Note</AlertTitle>
                                    Please select the appointing authority
                                    institution (if applicable). If the employee
                                    is being approved by an appointing authority
                                    institution—for example, if the employee
                                    works in the General Education sector and is
                                    approved by the Ministry of Education—then
                                    you should select the Ministry of Education
                                    as the appointing authority institution.
                                  </Alert>
                                </div>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  onClick={() => {
                                    setShowAppointingAuthorityInstitutionDialog(
                                      false,
                                    );
                                  }}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  onClick={() => {
                                    return handleUpdateAppointingAuthorityInstitutionRequest();
                                  }}
                                >
                                  Save
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </tr>
                        ) : (
                          <></>
                        )
                      }
                      {!!employeeExitRequest.statusComment && (
                        <tr
                          className={`border border-${
                            [3, 1002].includes(+employeeExitRequest.statusId)
                              ? "danger"
                              : "success"
                          }`}
                        >
                          <th scope="row">Last Review Comment</th>
                          <td>{employeeExitRequest.statusComment}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <div className="mt-3">
                    {" "}
                    <ViewExitRequestAttachments
                      exitTypeId={employeeExitRequest.exitTypeId}
                      requestId={employeeExitRequest.id}
                      canEdit={
                        !!hasPermissions(["IS_HR"]) &&
                        [1, 1003, 1005].includes(employeeExitRequest.statusId)
                      }
                    />
                  </div>
                </>
              )}
              {((conditions.enableToGenerateLetter && tabValue === 2) ||
                (!conditions.enableToGenerateLetter && tabValue === 1)) && (
                <>
                  <ViewApproverLogs requestId={employeeExitRequest.id} />
                </>
              )}
            </Box>
          )}
        </DialogContent>
        {employeeExitRequest && (
          <DialogActions>
            <Stack direction="row" spacing={2} className="mx-auto">
              {[1, 1003, 1004].includes(employeeExitRequest.statusId) && (
                <>
                  {!conditions.enableToGenerateLetter &&
                    !!hasPermissions(["IS_CBM"]) &&
                    [1, 1003, 1004].includes(employeeExitRequest.statusId) && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={
                            <span className="material-icons mr-1">
                              done_all
                            </span>
                          }
                          onClick={() => {
                            setNewStatusId(2);
                            setShowConfirmExit(true);
                          }}
                        >
                          Approve
                        </Button>

                        <Button
                          variant="contained"
                          color="warning"
                          endIcon={
                            <span className="material-icons mr-1">cancel</span>
                          }
                          onClick={() => {
                            setNewStatusId(3);
                            setShowConfirmExit(true);
                          }}
                        >
                          Reject
                        </Button>
                      </>
                    )}

                  {!!hasPermissions([
                    "IS_HEAD_OF_INSTITUTION",
                    "IS_HEAD_OF_INSTITUTION_ACTING",
                  ]) &&
                    [1003].includes(employeeExitRequest.statusId) &&
                    !!employeeExitRequest.appointingAuthorityPlanningEntityId &&
                    user.planningEntityId ===
                      employeeExitRequest.appointingAuthorityPlanningEntityId && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={
                            <span className="material-icons mr-1">
                              done_all
                            </span>
                          }
                          onClick={() => {
                            setShowApproveRequestForm(true);
                          }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          color="warning"
                          endIcon={
                            <span className="material-icons mr-1">cancel</span>
                          }
                          onClick={() => {
                            setNewStatusId(3);
                            setShowConfirmExit(true);
                          }}
                        >
                          Reject
                        </Button>
                      </>
                    )}

                  {!!hasPermissions([
                    "IS_HEAD_OF_INSTITUTION",
                    "IS_HEAD_OF_INSTITUTION_ACTING",
                  ]) &&
                    [1003].includes(employeeExitRequest.statusId) &&
                    !employeeExitRequest.appointingAuthorityPlanningEntityId &&
                    user.planningEntityId ===
                      employeeExitRequest.requestPlanningEntityId && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          startIcon={
                            <span className="material-icons mr-1">
                              done_all
                            </span>
                          }
                          onClick={() => {
                            if (conditions.enableToGenerateLetter) {
                              setShowApproveRequestForm(true);
                            } else {
                              setNewStatusId(2);
                              setShowConfirmExit(true);
                            }
                          }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="contained"
                          color="warning"
                          endIcon={
                            <span className="material-icons mr-1">cancel</span>
                          }
                          onClick={() => {
                            setShowRejectRequestForm(true);
                          }}
                        >
                          Reject
                        </Button>
                      </>
                    )}

                  {!!hasPermissions(["IS_HR"]) &&
                    [1010].includes(employeeExitRequest.statusId) && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          type="button"
                          disabled={loading}
                          onClick={() => {
                            setNewStatusId(1003);
                            setShowConfirmExit(true);
                          }}
                          className="btn btn-xs"
                        >
                          Confirm
                        </Button>
                        <Button
                          variant="contained"
                          color="warning"
                          endIcon={
                            <span className="material-icons mr-1">cancel</span>
                          }
                          onClick={() => {
                            setNewStatusId(1002);
                            setShowConfirmExit(true);
                          }}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  {!!hasPermissions(["IS_HR"]) &&
                    [1, 1004, 1010, 1003].includes(
                      employeeExitRequest.statusId,
                    ) &&
                    employeeExitRequest.employeeGroupId === 6 &&
                    !!employeeExitRequest.isAutoApprove && (
                      <>
                        <Button
                          variant="contained"
                          color="success"
                          type="button"
                          disabled={loading}
                          onClick={() => {
                            setNewStatusId(2);
                            setShowConfirmExit(true);
                          }}
                          className="btn btn-xs"
                        >
                          Accept
                        </Button>
                        <Button
                          variant="contained"
                          color="warning"
                          endIcon={
                            <span className="material-icons mr-1">cancel</span>
                          }
                          onClick={() => {
                            setNewStatusId(1002);
                            setShowConfirmExit(true);
                          }}
                        >
                          Cancel
                        </Button>
                      </>
                    )}

                  {!!hasPermissions(["IS_HR"]) &&
                    [1, 1004, 1003, 1010].includes(
                      employeeExitRequest.statusId,
                    ) && (
                      <Button
                        variant="contained"
                        color="warning"
                        startIcon={
                          <span className="material-icons">cancel</span>
                        }
                        onClick={() => {
                          setNewStatusId(1002);
                          setShowConfirmExit(true);
                        }}
                        disabled={loading}
                      >
                        {loading ? "Canceling..." : "Cancel request"}
                      </Button>
                    )}
                </>
              )}
            </Stack>
          </DialogActions>
        )}
      </Dialog>

      {showConfirmExit && (
        <ConfirmationDialog
          confirmationDialog={setShowConfirmExit}
          disabled={!reason}
          size="lg"
          message={
            <>
              <div className="my-2 py-2 px-3">
                <TextField
                  fullWidth
                  size="small"
                  multiline
                  rows={6}
                  name="reason"
                  label={`Give the reason that led to the ${
                    newStatusId === 3
                      ? "rejection"
                      : newStatusId === 1002
                        ? "cancellation"
                        : "confirmation"
                  } ..`}
                  variant="outlined"
                  placeholder={`Give the reason that led to the ${
                    newStatusId === 3
                      ? "rejection"
                      : newStatusId === 1002
                        ? "cancellation"
                        : "confirmation"
                  } ..`}
                  value={reason}
                  style={{ width: "600px" }}
                  onChange={(e) => {
                    setReason(e.target.value || "");
                  }}
                />
              </div>
            </>
          }
          setConfirmationDialog={setShowConfirmExit}
          onYes={() => {
            if (newStatusId === 2) {
              approveExitRequest(
                {
                  requestId: employeeExitRequest.id,
                  employeePositionId: employeeExitRequest.employeePositionId,
                  reason: reason,
                },
                onClose,
              );
            } else if (newStatusId === 1002) {
              cancelExitRequest(
                {
                  exitRequest: employeeExitRequest,
                  statusComment: reason,
                },
                onClose,
              );
            } else {
              handleConfirmRequest();
            }
          }}
        />
      )}
      {showCancelConfirmationDialog && employeeExitRequest && (
        <ConfirmationDialog
          confirmationDialog={showCancelConfirmationDialog}
          message={`Are you sure you want to cancel the exit request for ${
            employeeExitRequest?.lastName + " " + employeeExitRequest?.firstName
          }?`}
          setConfirmationDialog={setShowCancelConfirmationDialog}
          onYes={() => {
            cancelEmployeeExitRequest(employeeExitRequest, onClose);
          }}
        />
      )}
      {showRejectRequestForm && employeeExitRequest && (
        <ConfirmationDialog
          disabled={!reason}
          confirmationDialog={showRejectRequestForm}
          message={
            <>
              <p>
                Are you sure you want to{" "}
                <strong className="text-danger">reject</strong> this
                employeeExitRequest?
              </p>
              <TextField
                fullWidth
                size="small"
                multiline
                rows={4}
                name="Reason"
                label="Type your reason .."
                variant="outlined"
                placeholder="Type your reason  .."
                value={reason}
                onChange={(e) => {
                  setReason(e.target.value || "");
                }}
              />
            </>
          }
          setConfirmationDialog={setShowRejectRequestForm}
          onYes={() => {
            rejectRequest(
              {
                exitRequestId: employeeExitRequest.id,
                statusComment: reason,
              },
              onClose,
            );
          }}
        />
      )}
      {showApproveRequestForm && employeeExitRequest && (
        <ConfirmationDialog
          disabled={!pkiPassword}
          confirmationDialog={showApproveRequestForm}
          message={
            <>
              <p className="px-4">
                <SignLetter />
              </p>

              <p>Enter your RISA Digital signature password to sign</p>

              <form>
                <TextField
                  fullWidth
                  size="small"
                  id="pki-password"
                  rows={4}
                  name="pki-password"
                  type="password"
                  label="Enter your RISA Digital signature password to sign"
                  variant="outlined"
                  placeholder="Enter your RISA Digital signature password to sign"
                  value={pkiPassword}
                  onChange={(e) => {
                    setPkiPassword(e.target.value || "");
                  }}
                />
              </form>
            </>
          }
          setConfirmationDialog={setShowApproveRequestForm}
          onYes={() => {
            if (
              !!conditions.enableToGenerateLetter &&
              replacePlaceholders(employeeExitRequest.letterBodyContent, true)
            ) {
              showError(
                `Please update the following Placeholder: {appointingReferLetterNo}, {appointingReferLetterDate}`,
              );
              return false;
            }
            // Regular expression to match one or more occurrences of <div><br /></div>
            const regex = new RegExp('(<div><br></div>)+');

            // if (
            //   !!employeeExitRequest.enableToGenerateLetter &&
            //   // !!regex.test(employeeExitRequest.copiedInstitutionContent) &&
            //   !!ccEmails.length
            // ) {
            //   showError(
            //     `You've added the CC emails, but you didn't include the copied institution content.`
            //   );
            //   return false;
            // }

            // if (
            //   !!employeeExitRequest.enableToGenerateLetter &&
            //   !regex.test(employeeExitRequest.copiedInstitutionContent) &&
            //   !ccEmails.length
            // ) {
            //   showError(
            //     `You've included the copied institution content, but you didn't add the CC emails.`
            //   );
            //   return false;
            // }

            signExitRequest(
              {
                requestId: employeeExitRequest.id,
                password: pkiPassword,
                employeePositionId: employeeExitRequest.employeePositionId,
                cc: ccEmails || [],
                letterBodyContent: employeeExitRequest.letterBodyContent,
                copiedInstitutionContent:
                  employeeExitRequest.copiedInstitutionContent,
              },
              onClose,
            );
          }}
        />
      )}
    </>
  );
};

const mapStateToProps = ({
  loading,
  employeeExitRequest,
  entities,
  env,
  exitRequestAttachments,
  user,
  allPlanningEntities,
}) => {
  return {
    loading,
    employeeExitRequest,
    entities,
    env,
    exitRequestAttachments,
    user,
    allPlanningEntities,
  };
};
export default connect(mapStateToProps, {
  approveExitRequest,
  cancelExitRequest,
  rejectRequest,
  getEmployeeExitRequest,
  cancelEmployeeExitRequest,
  verifyExitRequest,
  saveOrUpdateDraftRequest,
  signExitRequest,
  getAllPlanningEntities,
  updateAppointingAuthorityInstitutionRequest,
})(ViewExitDialog);
